import React,{useEffect,useState} from "react";
import {useParams} from "react-router-dom";
import axios from "../../../utills/api";
import {
 Container,
 Card,
 CardBody
} from "reactstrap";
import {toast} from "react-toastify";

const HousekeepingTaskPage =()=>{
 const {
  requestId,
  taskId
 } = useParams();
 const [task,setTask]=useState(null);
 const fetchTask=async()=>{

  try{
   if(requestId){
    const res =
    await axios.get(
     `/requests/task/${requestId}`
    );
    setTask(
     res.data.request
    );
    return;
   }
   if(taskId){
    const res =
    await axios.get(
     `/housekeeping-task/${taskId}`
    );
    setTask(
     res.data.task
    );
    return;
   }
  }
  catch(err){
   console.error(err);
   toast.error(
    "Unable to load task"
   );

  }

 };

 useEffect(()=>{
  fetchTask();
 },[]);

 const updateStatus=async(status)=>{
  try{
   let finalStatus =
   status
   .trim()
   .toUpperCase()
   .replace(
    " ",
    "_"
   );
   if(requestId){

    await axios.patch(

     `/requests/task/${requestId}/status`,

     {
      status:finalStatus
     }

    );
   }

   if(taskId){
    await axios.patch(
     `/housekeeping-task/${taskId}/status`,
     {
      status:finalStatus
     }

    );

   }
   setTask(prev=>({
    ...prev,
    status:finalStatus
   }));

   toast.success(
    "Status Updated"
   );

  }
  catch(err){
   console.error(err);
   toast.error(
    err.response?.data?.message ||
    "Unable to update status"

   );

  }

 };

 if(!task){

  return(

   <div className="p-5 text-center">

    Loading...

   </div>

  );

 }
 return(

  <Container
   style={{
    maxWidth:700,
    marginTop:30
   }}
  >
   <Card>
    <CardBody>
     <h3>
      🧹 Housekeeping Task
     </h3>
     <hr/>
     <div>

      <b>Guest :</b>

      {task.guestName || "Hotel Task"}

     </div>
     <div>

      <b>Room :</b>

      {task.roomNumber}

     </div>
     <div>

      <b>Priority :</b>

      {task.priority}

     </div>

     <div>

      <b>Status :</b>
      <span className="badge bg-warning ms-2">

       {task.status}

      </span>
     </div>
     {
      task.services &&
      task.services.length > 0 &&
      (
       <>
       <hr/>
       <h5>
        Services
       </h5>
       <ul>
       {
        task.services.map(
         (item,index)=>(

          <li key={index}>

           {item}

          </li>

         )
        )
       }

       </ul>

       </>

      )
     }

     {
      task.description &&
      (
       <>
       <hr/>
       <div>
        <b>
         Description
        </b>
        <p>
         {task.description}
        </p>
       </div>
       </>
      )
     }
     {
      task.status !== "COMPLETED" &&
      (
       <div className="d-flex gap-2 flex-wrap">
        <button
         className="btn btn-info"
         onClick={()=>updateStatus(
          "IN_PROGRESS"
         )}

        >
         Start Cleaning
        </button>
        <button

         className="btn btn-success"

         onClick={()=>updateStatus(
          "COMPLETED"
         )}

        >
         Completed
        </button>
       </div>
      )
     }

    </CardBody>
   </Card>
  </Container>
 );
};
export default HousekeepingTaskPage;